var _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Google CoLaboratory",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "m46.7 151.5a147.8 147.8 90 000 208.9L97 310.1a76.6 76.6 90 01-.1-108.3zm368.4 50.3A76.6 76.6 90 01306.7 310.2L256 360.5a147.8 147.8 90 00209.3-209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd836"
    },
    d: "m96.9 201.8a76.6 76.6 90 01108.4 0l36.5-62.5A147.8 147.8 90 0046.7 151.5zm108.3 108.4a76.6 76.6 90 01-108.4 0l-50.1 50.3a147.8 147.8 90 00195.2 12zm101.1-.1a76.6 76.6 90 11108.4-108.4l50.6-50.2A147.8 147.8 90 00256 360.4z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColab);
export default __webpack_public_path__ + "static/media/colab.ee21a14aaf2c12779215585fa1dad84d.svg";
export { ForwardRef as ReactComponent };